import React, { Component } from 'react';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from '../../../dayjs/dayjs_timezone';
import BookingFieldsBlock from './BookingFieldsBlock';
import Price from './Price';
import RatesTable from '../../components/Common/RatesTable';
import Submit from './Submit';
import Table from '../../components/Common/Table';
import { convertDateFormat, formatHours } from '../../utilities/timeUtility';

dayjs.extend(localizedFormat);

export default class ActivitytConfirmationPage extends Component {
  componentDidMount() {
    const { getValidationQuantityFn, hasSeasonalRates, setWrapperHeight } = this.props;
    setWrapperHeight();
    if (getValidationQuantityFn) {
      getValidationQuantityFn(hasSeasonalRates ? this.validateRatesTableQuantity : this.validateTableQuantity);
    }
  }

  renderTable(lists) {
    const {
      capacityType,
      columns,
      extraColumns,
      hideHead,
      minimumQuantity,
      style,
      totalQuantity,
      translation,
      variants,
    } = this.props;

    if (lists.length === 0) return '';

    return (
      <Table
        getValidationFn={(validationFn) => { this.validateTableQuantity = validationFn; }}
        translation={translation}
        totalQuantity={totalQuantity}
        className="table-component"
        hideHead={hideHead}
        style={style}
        items={variants}
        columns={columns}
        extraColumns={extraColumns}
        limitedSpacesMessage={translation.key('limitedSpacesMessage')}
        capacityType={capacityType}
        minimumQuantity={minimumQuantity}
      />
    );
  }

  renderRatesTable(lists) {
    const {
      capacityType,
      columns,
      extraColumns,
      minimumQuantity,
      style,
      totalQuantity,
      translation,
      variants,
    } = this.props;

    if (lists.length === 0) return translation.key('noSeasons');

    return (
      <RatesTable
        getValidationFn={(validationFn) => { this.validateRatesTableQuantity = validationFn; }}
        translation={translation}
        totalQuantity={totalQuantity}
        style={style}
        items={variants}
        columns={columns}
        extraColumns={extraColumns}
        limitedSpacesMessage={translation.key('limitedSpacesMessage')}
        capacityType={capacityType}
        minimumQuantity={minimumQuantity}
      />
    );
  }

  render() {
    const {
      allDay,
      canBook,
      closeModal,
      columns: { lists },
      enabledBookingFields,
      getValidationFn,
      hasSeasonalRates,
      messages,
      onSubmit,
      region,
      style,
      selectedTimeslot,
      setting,
      setWrapperHeight,
      timeZone,
      totalQuantity,
      translation,
      variantsAvailability,
      dateFormat,
      timeInterval,
    } = this.props;

    const format = convertDateFormat(region);
    let date = dayjs(selectedTimeslot).locale(region).tz(timeZone).format(format);

    if (!allDay) date += ` ${formatHours(selectedTimeslot, region, timeZone, setting.time_format)}`;

    return (
      <div>
        <button type="button" className="btn-back-title" style={style.body} onClick={closeModal}>
          <i className="fa fa-arrow-left fa-2" aria-hidden="true" />
        </button>

        <h3 className="text-center widget-title" style={{ ...style.title, minHeight: '16px' }}>
          {translation.key('modalTitle')}
        </h3>

        <p className="text-left">{translation.key('modalSubTitle')}</p>

        <p className="text-left bold">{date}</p>

        <div className="relative">
          <div
            className="variants-container"
            style={{ paddingBottom: '16px', marginBottom: '16px', borderBottom: '1px solid' }}
          >
            {hasSeasonalRates ? this.renderRatesTable(lists) : this.renderTable(lists)}
          </div>

          {enabledBookingFields
            && (
            <BookingFieldsBlock
              translation={translation}
              getValidationFn={(validationFn) => getValidationFn(validationFn)}
              willUpdate={() => setWrapperHeight()}
              totalQuantity={totalQuantity}
              timeZone={timeZone}
              timeInterval={timeInterval}
              dateFormat={dateFormat}
            />
            )}

          <Price title={`${translation.key('price')}`} />
        </div>

        <Submit
          canBook={canBook && variantsAvailability && lists.length > 0}
          messages={messages}
          onSubmit={(e) => onSubmit(e)}
        />
      </div>
    );
  }
}
